import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  const handleNavClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const navLinks = [
    { labelKey: 'nav.home', href: '#inicio' },
    { labelKey: 'nav.catalog', href: '#catalogo' },
    { labelKey: 'nav.import', href: '#importacion' },
    { labelKey: 'nav.featured', href: '#destacados' },
    { labelKey: 'nav.contact', href: '#contacto' },
  ];

  const serviceKeys = [
    'footer.service1',
    'footer.service2',
    'footer.service4',
    'footer.service5',
  ];

  return (
    <footer className="bg-[#030303] border-t border-purple-900/20 relative overflow-hidden">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-5 pointer-events-none">
        <div
          className="absolute top-0 left-0 w-full h-full"
          style={{
            backgroundImage: 'radial-gradient(circle at 2px 2px, rgba(155,48,255,0.4) 1px, transparent 0)',
            backgroundSize: '40px 40px',
          }}
        />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 py-12 sm:py-16 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <img
              src="https://static.readdy.ai/image/0c7bdc23c0509608cd59066307fba6e0/19dd2d639fbad16ddbf690588f9b26c2.png"
              alt="ZS Cars Import"
              className="h-20 w-auto object-contain mb-4"
            />
            <p className="text-white/40 text-sm leading-relaxed mb-6">
              {t('footer.brand.desc')}
            </p>
            <div className="flex gap-3">
              <a
                href="https://www.instagram.com/zs.importaciones_"
                rel="nofollow"
                target="_blank"
                className="w-9 h-9 flex items-center justify-center border border-white/10 rounded-lg text-white/40 hover:text-purple-400 hover:border-purple-500/40 transition-all duration-300 cursor-pointer"
              >
                <i className="ri-instagram-line text-sm" />
              </a>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="font-label text-white text-xs tracking-widest uppercase mb-5">
              <a href="#inicio">{t('footer.nav.title')}</a>
            </h4>
            <ul className="flex flex-col gap-3">
              {navLinks.map((link) => (
                <li key={link.labelKey}>
                  <button
                    onClick={() => handleNavClick(link.href)}
                    className="text-white/40 hover:text-purple-400 text-sm transition-colors duration-300 cursor-pointer whitespace-nowrap"
                  >
                    {t(link.labelKey)}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-label text-white text-xs tracking-widest uppercase mb-5">
              <a href="#importacion">{t('footer.services.title')}</a>
            </h4>
            <ul className="flex flex-col gap-3">
              {serviceKeys.map((key) => (
                <li key={key}>
                  <span className="text-white/40 text-sm">{t(key)}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-label text-white text-xs tracking-widest uppercase mb-5">
              <a href="#contacto">{t('footer.contact.title')}</a>
            </h4>
            <ul className="flex flex-col gap-4">
              <li className="flex items-start gap-3">
                <i className="ri-whatsapp-line text-purple-400 mt-0.5 flex-shrink-0" />
                <a href="https://wa.me/34631611077" rel="nofollow" className="text-white/40 hover:text-white text-sm transition-colors duration-300">
                  +34 631 611 077
                </a>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-mail-line text-purple-400 mt-0.5 flex-shrink-0" />
                <a href="mailto:z.s.carsimport@gmail.com" rel="nofollow" className="text-white/40 hover:text-white text-sm transition-colors duration-300">
                  z.s.carsimport@gmail.com
                </a>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-instagram-line text-purple-400 mt-0.5 flex-shrink-0" />
                <a href="https://www.instagram.com/zs.importaciones_" rel="nofollow" className="text-white/40 hover:text-white text-sm transition-colors duration-300">
                  @ZS CARS IMPORT
                </a>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-map-pin-line text-purple-400 mt-0.5 flex-shrink-0" />
                <span className="text-white/40 text-sm">{t('contact.location.value')}</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-time-line text-purple-400 mt-0.5 flex-shrink-0" />
                <span className="text-white/40 text-sm">{t('contact.schedule.value')}</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="h-px bg-gradient-to-r from-transparent via-purple-500/20 to-transparent mb-8" />

        {/* Bottom */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/20 text-xs">
            {t('footer.rights')}
          </p>
          <div className="flex gap-6">
            <a href="#" rel="nofollow" className="text-white/20 hover:text-white/50 text-xs transition-colors duration-300">
              {t('footer.privacy')}
            </a>
            <a href="#" rel="nofollow" className="text-white/20 hover:text-white/50 text-xs transition-colors duration-300">
              {t('footer.legal')}
            </a>
            <a href="#" rel="nofollow" className="text-white/20 hover:text-white/50 text-xs transition-colors duration-300">
              {t('footer.cookies')}
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}